import type { PagesMenu } from "@/types/pagesMenu";

/**
 * Menu lateral do layout desktop (default.vue).
 * Rotinas conforme SIST_MAINFORM (Harpia_WMS).
 */
export const menuStation: PagesMenu[] = [
	{
		label: "Início",
		icon: "pi pi-fw pi-home",
		items: [
			{
				label: "Painel operacional",
				icon: "pi pi-fw pi-home",
				to: "/",
				nome: "Home" as any,
				visible: true,
			},
		],
	},
	{
		label: "Gestão de acessos",
		icon: "pi pi-fw pi-users",
		items: [
			{
				// ACEUSU_ID_MENU_PF = mni_CadastroUsuario (SIST_MAINFORM) e/ou "1150"
				label: "1150 — Cadastro de Usuários",
				icon: "pi pi-fw pi-user",
				to: "/gestaoAcessos/1150",
				nome: "mni_CadastroUsuario" as any,
				visible: true,
			},
			{
				label: "1151 — Acesso às opções",
				icon: "pi pi-fw pi-lock",
				to: "/gestaoAcessos/1151",
				nome: "mni_Concesso_Acesso_Opcoes_Sistema" as any,
				visible: true,
			},
			{
				label: "1152 — Liberações diversas",
				icon: "pi pi-fw pi-key",
				to: "/gestaoAcessos/1152",
				nome: "mni_Concessao_Liberacoes_Diversas" as any,
				visible: true,
			},
		],
	},
	{
		label: "Logística",
		icon: "pi pi-fw pi-box",
		items: [
			{
				label: "1230 — Dados logísticos",
				icon: "pi pi-fw pi-database",
				to: "/logistica/1230",
				nome: "N1230_DadosLogisticosMercadoria" as any,
				visible: true,
			},
			{
				label: "1241 — Locais / endereços",
				icon: "pi pi-fw pi-map-marker",
				to: "/logistica/1241",
				nome: "mni_Log_RecAdicLogDep_LocProEstFin" as any,
				visible: true,
			},
		],
	},
	{
		label: "Gestão de Não Conformidade",
		icon: "pi pi-fw pi-exclamation-triangle",
		items: [
			{
				/**
				 * 721 — somente consulta nesta etapa
				 * (modules/PROC_CONTROLE_NAO_CONFORMIDADE).
				 *
				 * `nome` ficou com o código da rotina, e não com um `mni_`, porque
				 * `CORE_MENU` e `T091_OPCOES_MENU` estão vazias na base: o id Delphi
				 * não pôde ser confirmado. `useSetMenusStation` também casa a
				 * permissão pelo código do rótulo, então `721` no
				 * `ACEUSU_ID_MENU_PF` já libera o item.
				 */
				label: "721 — Atribuição das Mercadorias a Não Conformidade",
				icon: "pi pi-fw pi-flag",
				to: "/processos/atribuicao-nao-conformidade",
				nome: "721" as any,
				visible: true,
			},
		],
	},
	/**
	 * Recepção fica imediatamente acima de Expedição para o menu acompanhar a
	 * ordem do fluxo do galpão: a mercadoria entra pela recepção e sai pela
	 * expedição.
	 *
	 * A rota continua `/recebimento/...` — só o rótulo do tópico mudou, e
	 * renomear caminho invalidaria link salvo de quem já está testando.
	 */
	{
		label: "Recepção",
		icon: "pi pi-fw pi-inbox",
		items: [
			{
				/*
				 * `nome` conferido no catálogo de captions do próprio projeto
				 * (`menuCaptions.catalog.json`), que é transcrição do menu do
				 * Delphi: mni_PRO_RECMER_AbaEndMov -> "216 - Acondicionamento das
				 * Mercadorias nas Posições de Armazenamento".
				 *
				 * Não confundir com os vizinhos: a 215 é
				 * `AcondicionamentoSimplificad`, a 217 é a de devolução
				 * (`mni_PRO_RECMER_AbEndMovDev`) e a 219 tem caption idêntica mas
				 * é outra rotina (`mni_PRO_RECMER_ProcLogRecpMerc`).
				 *
				 * Na HPANORD o id está liberado para 108 usuários, entre eles o 5004.
				 */
				label: "216 — Acondicionamento das Mercadorias nas Posições de Armazenamento",
				icon: "pi pi-fw pi-th-large",
				to: "/recebimento/acondicionamento",
				nome: "mni_PRO_RECMER_AbaEndMov" as any,
				visible: true,
			},
		],
	},
	{
		label: "Expedição",
		icon: "pi pi-fw pi-truck",
		items: [
			{
				label: "34A — Status da Separação de Mercadorias",
				icon: "pi pi-fw pi-chart-bar",
				to: "/consulta/CONS_STATUS_SEPARACAO_MERCADORIAS",
				nome: "StatusdaSeparaodeMercadorias1" as any,
				visible: true,
			},
			{
				/*
				 * Estava no menu do coletor rotulada como "B332", número que
				 * pertence à Liberação do Palete para Armazenamento. O catálogo de
				 * captions do Delphi dá a esta rotina o código 362, e a tela é de
				 * desktop. Corrigido em 28/09/2026.
				 */
				label: "362 — Liberação de Divergências da Separação Carga Consolidada",
				icon: "pi pi-fw pi-unlock",
				to: "/liberacao/divergencias",
				nome: "mni_LiberacaoDivergenciasSeparacaoConsolidada" as any,
				visible: true,
			},
			{
				label: "363 — Monitoramento cargas consolidadas",
				icon: "pi pi-fw pi-th-large",
				to: "/monitoramento/cargas-consolidadas",
				nome: "mni_MonitoramentoCargasConsolidadas" as any,
				visible: true,
			},
		],
	},
	/**
	 * Painéis de supervisão (TV) — fontes em `acompanhamento-logistica/`.
	 * Requer frontend Vite :5174 + backend API :3010 rodando (ver README da pasta).
	 */
	{
		label: "Acompanhamento",
		icon: "pi pi-fw pi-chart-line",
		items: [
			{
				label: "Recursos Servidor",
				icon: "pi pi-fw pi-server",
				to: "/acompanhamento/capacidade-coletores",
				nome: "mni_AcompanhamentoCapacidadeColetores" as any,
				visible: true,
			},
			{
				// Tela nativa PrimeVue (modules/ACOMPANHAMENTO_SEPARACAO)
				label: "A333 — Acompanhamento Separação",
				icon: "pi pi-fw pi-box",
				to: "/acompanhamento/separacao",
				nome: "mni_AcompanhamentoSeparacao" as any,
				visible: true,
			},
			{
				label: "Separação Volumes Caixaria",
				icon: "pi pi-fw pi-box",
				to: "/acompanhamento/separacao-volumes-caixaria",
				nome: "mni_AcompanhamentoSeparacaoVolumesCaixaria" as any,
				visible: true,
			},
			{
				label: "Acompanhamento Inventário",
				icon: "pi pi-fw pi-list",
				to: "/acompanhamento/inventario",
				nome: "mni_AcompanhamentoInventario" as any,
				visible: true,
			},
			{
				label: "A331 - Acompanhamento Convocação Ativa",
				icon: "pi pi-fw pi-directions",
				to: "/acompanhamento/convocacao-ativa",
				nome: "mni_AcompanhamentoConvocacaoAtiva" as any,
				visible: true,
			},
			{
				label: "Estoque por Curva Financeira",
				icon: "pi pi-fw pi-chart-bar",
				to: "/acompanhamento/estoque-curva-financeira",
				nome: "mni_AcompanhamentoEstoqueCurvaFinanceira" as any,
				visible: true,
			},
			{
				// A424 — produção do dia e remuneração por produtividade
				// (relatório Delphi LIST_PRODUTIVIDADE_REMUNERACAO).
				// Uma tela só, com separação (05/07) e conferência (06/08) lado a lado.
				label: "A424 — Produtividade Separador/Conferente de Expedição",
				icon: "pi pi-fw pi-users",
				to: "/acompanhamento/produtividade-remuneracao",
				nome: "mni_Remuneracao_Produtividade_Geral" as any,
				visible: true,
			},
		],
	},
];
